import NiceModal, { useModal } from '@ebay/nice-modal-react';
import Drawer from '@/components/Modals/Drawer';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import CsvImporter from '../CsvImporter/CsvImporter';
import { IContact } from './ContactForm';
import ContactForm from './ContactForm';

interface DrawerProps {
  contact?: IContact;
}

const ContactFormDrawer = NiceModal.create(({ contact }: DrawerProps) => {
  const modal = useModal('contact-form-drawer');

  return (
    <Drawer modal={modal} title={contact?.id ? 'Edit Contact' : 'Add Contact'}>
      <Tabs defaultValue="manual" className="w-full">
        <TabsList>
          <TabsTrigger value="manual">Add Manually</TabsTrigger>
          <TabsTrigger value="csv">Import CSV</TabsTrigger>
        </TabsList>

        <TabsContent value="manual">
          <ContactForm contact={contact} onClose={() => modal.hide()} />
        </TabsContent>

        <TabsContent value="csv">
          <CsvImporter />
        </TabsContent>
      </Tabs>
    </Drawer>
  );
});

export default ContactFormDrawer;
